import { createContext, type Dispatch, type SetStateAction } from 'react'

import { type User } from 'components/admin/types'
import { type getReimbursementsQueryKey, type ReimbursementsFilters } from 'components/hooks/reimbursements/useGetReimbursementRequests'

export type ReimbursementsContextType = {
  currentUser?: User
  setFilters: Dispatch<SetStateAction<ReimbursementsFilters>>
  getReimbursementsQueryKey: ReturnType<typeof getReimbursementsQueryKey>
}

const ReimbursementsContext = createContext<ReimbursementsContextType>({
  currentUser: undefined,
  setFilters: () => { },
  getReimbursementsQueryKey: [],
})

export default ReimbursementsContext
